import React from "react";
import Loadable from "../../react-loadable";
import { formatToDate as formatDate } from "../wea-tools/format";
import "./index.less";

const WeaDatePicker = Loadable({
  loader: () => import("./Main"),
  loading: obj => {
    if (obj && obj.props) {
      const {
        props: { fieldName, value, formatPattern, formatWithZero = true }
      } = obj;
      const inputValue = value
        ? formatDate(value, formatPattern || 2, formatWithZero)
        : value;
      return (
        <input
          ecId={`${obj.props.ecId}_input@si3r8a`}
          type="hidden"
          id={fieldName}
          name={fieldName}
          value={inputValue}
        />
      );
    }
    return null;
  },
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaDatePicker;



// WEBPACK FOOTER //
// ./ecology9/wea-date-picker/index.js